import React from 'react';

import styles from './binance-field.module.scss';

export const binace_field_provided = (
  <div>
    <p>Form successfully submitted!</p>
    <p className={styles.binanceFieldPrompt}>Thanks so much for signing up for Pangaea!</p>
    <p className={styles.binanceFieldPrompt}>
      Once we verify your Binance Referral ID, you will receive an e-mail that includes your unique
      ‘Pangaea Code’ with next steps. Your unique Pangaea Code will give you access to running a
      Harmony node. :-)
    </p>
    <p className={styles.binanceFieldPrompt}>
      IMPORTANT: Please make sure that you’ve entered a valid Binance ID. If you are not sure
      whether you have entered a valid Binance ID, please visit
      {'<Binance URL>'} to obtain your unique Binance ID and resubmit this form. If you cannot
      obtain a Binance ID, please resubmit this form leaving the ‘Binance ID’ field empty. After you
      received your unique ‘Pangaea Code’, you can go to
      <a href={'https://pangaea.harmony.one/pkg'}> https://pangaea.harmony.one/pkg </a>
      to download your keys.
    </p>
    <p className={styles.binanceFieldPrompt}>
      After you receive your unique ‘Pangaea Code’, you can go to _PKG_URL_ to download your keys
      that will help you run a node. You can start reading about how to run a Pangaea node here
      _Gitbook_link_. text for the page once a user has entered the verification pin
    </p>
  </div>
);

export const binace_field_not_provided = (
  <div>
    <p>Form successfully submitted!</p>
    <p className={styles.binanceFieldPrompt}>Thanks so much for signing up for Pangaea!</p>
    <p className={styles.binanceFieldPrompt}>
      We have received your application for Pangaea. Please confirm your KYC by completing this form
      on Coinlist:
      <a href={'https://tsm.coinlist.co/harmony-pangea'}> Coinlist identification for Pangaea </a>.
      Once we verify your ID via Coinlist, you will receive a confirmation e-mail including your
      unique ‘Pangaea Code’ and next steps. You will need your Pangaea code to generate your keys
      before you can start setting up your node.
    </p>
    <p className={styles.binanceFieldPrompt}>
      IMPORTANT: Please note the e-mail address that you’ve entered needs to match your e-mail
      registered in Coinlist. If you have submitted a different e-mail in this form, please resubmit
      this form using your registered Coinlist e-mail
    </p>
    <p className={styles.binanceFieldPrompt}>
      After you receive your unique ‘Pangaea Code’, you can go to _PKG_URL_ to download your keys
      that will help you run a node. You can start reading about how to run a Pangaea node here
      _Gitbook_link_. text for the page once a user has entered the verification pin
    </p>
  </div>
);
